import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getReports(pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/algolia-product/country/${Enviroment.LANGUAGE}`,
			params: { pharmacy: pharmacy },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
